
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { EnumClasshourStatus } from '@xt/client/enums'
import type { ClasshourDirectionStyle, ClasshourUIStatus, FormatedBiShanInfo } from '@xt/client/utils/classhour-map/types.d'

@Observer
@Component({
  components: {}
})
export default class MapClasshour extends Vue {
  @Prop({ required: true }) classhourId: number
  @Prop({ required: true }) title: string
  @Prop({ required: true }) dir: ClasshourDirectionStyle
  @Prop({ required: true }) cover: string
  @Prop({ required: true }) uiStatus: ClasshourUIStatus
  @Prop({ required: true }) bishanList: FormatedBiShanInfo[]

  get EnumClasshourStatus() {
    return EnumClasshourStatus
  }

  handleClickBiShanItem(item: FormatedBiShanInfo) {
    console.log(JSON.stringify(item, undefined, 2))
    if (item.type === 'live') {
      if (!item.isPublish) {
        this.$message.error('课时未发布')
        return
      } else if (item.isLiveEnd && item.isPlaybackNotGenerated) {
        // 回放还没有生成 不处理
        console.log('回放还没有生成 不处理')
      } else if (item.todayLive) {
        // 今天有直播 去直播间
        window.open(`/live?classhour=${item.classhourId}`, '_blank')
      } else if (item.todayPlayback) {
        // 今天有回放 去回放
        window.open(`/playback?classhour=${item.classhourId}`, '_blank')
      } else if (!item.isLiveStart) {
        this.$message.error('直播未开始')
      } else if (item.isPlaybackEnd) {
        this.$message.error('回放已结束')
      }
    } else {
      // 点击作业笔山 等价于点击整个课时区域 打开课时弹窗即可
      this.$emit('click')
    }
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
